import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


import CowieRoadShop from "./sections/CowieRoad.jsx"
import OverportShop from "./sections/Overport.jsx"
import FloridaShop from "./sections/FloridaRoad.jsx"
import DurbanNorthShop from './sections/DurbanNorth.jsx'
import IsipingoShop from './sections/Isipingo.jsx'

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";


import ContactPageStyle from "assets/jss/material-kit-react/views/ContactPage.jsx";

// Sections for this page


const dashboardRoutes = [];

class ContactPage extends React.Component { 
    render() {
        const { classes, ...rest } = this.props;
        return (
            <div>
                <Header
                    color="transparent"
                    routes={dashboardRoutes}
                    brand="Rooftop420"
                    rightLinks={<HeaderLinks />}
                    fixed
                    changeColorOnScroll={{
                        height: 400,
                        color: "white"
                    }}
                    {...rest}
                />
                <Parallax filter image={require("assets/img/together.jpg")}>
                    <div className={classes.container}>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                                <h1 className={classes.title}>Contact us</h1>
                                <h4>
                                    Find us at one of our conveniently located stores!
                </h4>
                            </GridItem>
                        </GridContainer>
                    </div>
                </Parallax>
                <div className={classNames(classes.main, classes.mainRaised)}>
                    <div className={classes.container}>
                        <CowieRoadShop />
                        <OverportShop />
                        <FloridaShop />
                        <IsipingoShop />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

export default withStyles(ContactPageStyle)(ContactPage);
